import { DatePicker } from "antd";
import moment from "moment";

export default function DatePickerInput({ value, change }) {
  return <DatePicker defaultValue={moment(value)} onChange={change} />;
}
